import '../BonusFans/BonusFans.sass';

import React, { FC, useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Header, Placeholder, ScrollView } from '$uikit';
import { Api } from '$api';
import { useTranslator } from '$hooks';
import { mainActions } from '$store/main';
import { toastActions } from '$store/toast';
import { Loader, UserCell } from '$shared/components';
import { batchActions } from '$store';
import { inviteActions, inviteSelector } from '$store/invite';

export const BonusFansReferrals: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const [loadingStatus, setLoadingStatus] = useState('loading');
  const { bonusFansReferrals, bonusFansReferralAmounts } = useSelector(inviteSelector);

  const loadData = useCallback(() => {
    setLoadingStatus('loading');
    Api.get<any, any>('/invite/bonus/referrals')
      .then((data) => {
        const fans = Object.keys(data.bonusAmounts).map(Number);
        dispatch(
          batchActions(
            mainActions.setUsers(data.users),
            inviteActions.setBonusFansReferrals({
              fans,
              bonusAmounts: data.bonusAmounts,
            }),
          ),
        );
        setLoadingStatus('');
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
        setLoadingStatus('failed');
      });
  }, []);

  useMemo(() => {
    loadData();
  }, []);

  function renderContent() {
    if (loadingStatus === 'loading' && bonusFansReferrals.length === 0) {
      return <Loader isWrapped />;
    }

    if (loadingStatus === 'failed') {
      return (
        <Placeholder
          title={t('failed_title')}
          actions={
            <Button size="small" onClick={loadData}>
              {t('failed_button')}
            </Button>
          }
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    if (bonusFansReferrals.length === 0) {
      return <Placeholder centered>{t('bonus_fans_modal_empty')}</Placeholder>;
    }

    return (
      <>
        <div className="BonusFans__caption">{t('bonus_fans_referrals_info')}</div>
        {bonusFansReferrals.map((fan) => (
          <UserCell
            key={fan}
            objectId={fan}
            caption={`+${bonusFansReferralAmounts[fan] || 0} bonus fans`}
          />
        ))}
      </>
    );
  }

  return (
    <>
      <Header showBackButton>{t('bonus_fans_referrals_title')}</Header>
      <ScrollView>{renderContent()}</ScrollView>
    </>
  );
};
